// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment_d6hyJ {
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  border-bottom: 1px solid #e2f4f0;
  cursor: default;
  gap: 10px;
  &:hover {
    background-color: var(--f0-border);
  }
  .icon_YgfRS {
    width: 50px;
    height: 50px;
    min-width: 50px;
    background: #e2f4f0;
    border-radius: 50%;
  }
  .content_V94cP {
    display: flex;
    flex-direction: column;
    width: 100%;
    > div {
      display: flex;
      align-items: center;
      width: 100%;
      b {
        font-size: 12px;
        font-weight: 600;
      }
      button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 14px;
        color: var(--_10a37f-background);
      }
    }
    span {
      font-size: 12px;
      color: var(--_6-color);
    }
    .delete_IyDeD {
      width: 20px;
      height: 20px;
      background: red;
      border-radius: 50%;
    }
  }
}

.attachmentChilds_SwmLm {
  display: flex;
  align-items: start;
  justify-content: start;
  padding: 10px;
  border-bottom: 1px solid #e2f4f0;
  cursor: default;
  gap: 10px;
  padding-left: 30px;
}
.iconImages_G9k0L {
  width: 100%;
  height: 100%;
}

.wasImported_fEUSW {
  padding-left: 6px;
}

.loaderImportConnectionAttachment__jr6S {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: relative;
  animation: rotate_lJ3DG 1s linear infinite;
}
.loaderImportConnectionAttachment__jr6S::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 2px solid var(--_10a37f-background);
  animation: prixClipFix_qRBHA 2s linear infinite;
}

@keyframes rotate_lJ3DG {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix_qRBHA {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}

.viewMoreContainer_zBy6M {
  width: 100%;
  margin-top: 4px;
}

.viewMoreButton_dCRL_ {
  width: 100%;
  background: var(--_10a37f-background);
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #e2f4f0;
  height: 28px;
  border-radius: 6px;
  &:hover {
    background: #10a37ede;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AttachmentNotificationOut/AttachmentNotificationOut.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT;IACE,kCAAkC;EACpC;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX;QACE,eAAe;QACf,gBAAgB;MAClB;MACA;QACE,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;QACf,gCAAgC;MAClC;IACF;IACA;MACE,eAAe;MACf,sBAAsB;IACxB;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAAoC;AACtC;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,+CAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,gEAAgE;EAClE;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,mEAAmE;EACrE;EACA;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".attachment {\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  flex-direction: column;\n  padding: 10px;\n  border-bottom: 1px solid #e2f4f0;\n  cursor: default;\n  gap: 10px;\n  &:hover {\n    background-color: var(--f0-border);\n  }\n  .icon {\n    width: 50px;\n    height: 50px;\n    min-width: 50px;\n    background: #e2f4f0;\n    border-radius: 50%;\n  }\n  .content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    > div {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      b {\n        font-size: 12px;\n        font-weight: 600;\n      }\n      button {\n        background: none;\n        border: none;\n        cursor: pointer;\n        font-size: 14px;\n        color: var(--_10a37f-background);\n      }\n    }\n    span {\n      font-size: 12px;\n      color: var(--_6-color);\n    }\n    .delete {\n      width: 20px;\n      height: 20px;\n      background: red;\n      border-radius: 50%;\n    }\n  }\n}\n\n.attachmentChilds {\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  padding: 10px;\n  border-bottom: 1px solid #e2f4f0;\n  cursor: default;\n  gap: 10px;\n  padding-left: 30px;\n}\n.iconImages {\n  width: 100%;\n  height: 100%;\n}\n\n.wasImported {\n  padding-left: 6px;\n}\n\n.loaderImportConnectionAttachment {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite;\n}\n.loaderImportConnectionAttachment::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 2px solid var(--_10a37f-background);\n  animation: prixClipFix 2s linear infinite;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n  }\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);\n  }\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n  }\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n  }\n}\n\n.viewMoreContainer {\n  width: 100%;\n  margin-top: 4px;\n}\n\n.viewMoreButton {\n  width: 100%;\n  background: var(--_10a37f-background);\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #e2f4f0;\n  height: 28px;\n  border-radius: 6px;\n  &:hover {\n    background: #10a37ede;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachment": `attachment_d6hyJ`,
	"icon": `icon_YgfRS`,
	"content": `content_V94cP`,
	"delete": `delete_IyDeD`,
	"attachmentChilds": `attachmentChilds_SwmLm`,
	"iconImages": `iconImages_G9k0L`,
	"wasImported": `wasImported_fEUSW`,
	"loaderImportConnectionAttachment": `loaderImportConnectionAttachment__jr6S`,
	"rotate": `rotate_lJ3DG`,
	"prixClipFix": `prixClipFix_qRBHA`,
	"viewMoreContainer": `viewMoreContainer_zBy6M`,
	"viewMoreButton": `viewMoreButton_dCRL_`
};
export default ___CSS_LOADER_EXPORT___;
